import { Component, OnInit, Input, EventEmitter, Output, HostListener, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule, FormsModule, AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';
import { DataService} from '../../shared/services/dataService'
import {Observable, Subject, merge, ReplaySubject} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, filter} from 'rxjs/operators';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { SearchCase } from 'app/shared/models/caseModel';
import { CustomErrorMatcher } from './customErrorMatcher';



@Component({
    selector: 'search',
    templateUrl: './search.html',
    styles: [' .error{color: #a94442; font-size: medium;}'],
    styleUrls: ['./search.component.css']
})

export class SearchComponent  implements OnInit, OnDestroy {
  static dateRangeValidator(group: FormGroup): { [key: string]: any} {
    var start:AbstractControl = group.controls['start'];
    var end:AbstractControl = group.controls['end'];

    if(start.errors || end.errors || (start.value && !end.value) || (!start.value && end.value)) {
      return {
        "dateRange": true
      };
    }
    return null;
  }

  static dateValidator(control: FormControl): { [key: string]: any} {
    if(control.value) {
      var year = control.value.getFullYear();

      if(year < 1000 || year > 9999) {
        return {
          "dateValidator": true
        };
      }
    }
    return null;
  }

  counties: string[];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  @Input() searchCase: SearchCase;
  @Input() isAdmin;
  @Output() search: EventEmitter<SearchCase> = new EventEmitter();
  @ViewChild('instance', {static:true}) instance: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();
  groups: any;
  errorMatcher:CustomErrorMatcher = new CustomErrorMatcher();
  dateRangeLabel: string = "MM/DD/YYYY - MM/DD/YYYY"
  doblabel: string = this.dateRangeLabel;
  dodlabel: string = this.dateRangeLabel;
  dobRange = new FormGroup({
    start: new FormControl(null, SearchComponent.dateValidator),
    end: new FormControl(null, SearchComponent.dateValidator),
  }, SearchComponent.dateRangeValidator);

  dodRange = new FormGroup({
    start: new FormControl(null, SearchComponent.dateValidator),
    end: new FormControl(null, SearchComponent.dateValidator),
  }, SearchComponent.dateRangeValidator);


  constructor(private dataService: DataService) {
  }
  ngOnInit() {
     this.dataService.getLookUps().takeUntil(this.destroyed$).subscribe( r => {
      this.counties = r.Groups[0].groups;
    });

    this.dobRange.controls['start'].valueChanges.subscribe(value => {
      this.unsetLabel('dob');
      this.setLabel('dob');
    });

    this.dobRange.controls['end'].valueChanges.subscribe(value => {
      this.unsetLabel('dob');
      this.setLabel('dob');
    });

    this.dodRange.controls['start'].valueChanges.subscribe(value => {
      this.unsetLabel('dod');
      this.setLabel('dod');
    });

    this.dodRange.controls['end'].valueChanges.subscribe(value => {
      this.unsetLabel('dod');
      this.setLabel('dod');
    });
  }
  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  searchCounties = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance?.isPopupOpen()));
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.counties
        : this.counties.filter(v => v.toLowerCase().includes(term.toLowerCase())))
    ));
 }

 unsetLabel(type: string) {
  if(type == "dob") {
    this.doblabel = "";
  } else {
    this.dodlabel = "";
  }
}

setLabel(type: string) {
  if(type == "dob") {
    var start = this.dobRange.value['start'];
    var end = this.dobRange.value['end'];
    if((start == null || start === '') && (end == null || end === '')) {
      this.doblabel = this.dateRangeLabel;
    }
  } if(type=='dod') {
    var start = this.dodRange.value['start'];
    var end = this.dodRange.value['end'];
    if((start == null || start === '') && (end == null || end === '')) {
      this.dodlabel = this.dateRangeLabel;
    }
  }
}

  @HostListener('onSearch')
  onSearch() {
    this.searchCase.dateOfBirthFrom = !this.dobRange.value['start'] ? "" : this.dobRange.value['start'];
    this.searchCase.dateOfBirthTo = !this.dobRange.value['end'] ? "" : this.dobRange.value['end'];
    this.searchCase.dateOfDeathFrom = !this.dodRange.value['start'] ? "" : this.dodRange.value['start'];
    this.searchCase.dateOfDeathTo = !this.dodRange.value['end'] ? "" : this.dodRange.value['end'];
    if(!this.dobRange.valid || !this.dodRange.valid) {
      alert("Please make sure the date fields are filled in correctly!");
      return;
    }

    this.search.emit(this.searchCase);
  }
  onSelectResidentCounty(county) { this.searchCase.residentCounty = county; }
  onSelectIncidentCounty(county) { this.searchCase.incidentCounty = county; }
  }

